import { Input } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { CountyCitySelect } from 'components/core-ui/CountyCitySelect'
import { LocationFormItem } from 'components/location/interfaces'
import { CountyCityInterface } from 'components/supplyomni/SelectClient/NewClient/interfaces'
import { FormikProps } from 'formik'

interface NewAddressProps {
  formik: FormikProps<LocationFormItem>
}

const NewAddress = (props: NewAddressProps) => {
  const { formik } = props
  return (
    <>
      <Grid item xs={12}>
        <CountyCitySelect
          required
          county={{
            action: {
              url: '/location-management/counties',
              type: 'GET',
              valueKey: 'id',
              labelKey: 'name'
            },
            width: 100,
            label: 'County',
            variant: 'outlined'
          }}
          city={{
            action: {
              url: '/location-management/cities',
              type: 'GET',
              valueKey: 'id',
              labelKey: 'name'
            },
            width: 100,
            label: 'City',
            variant: 'outlined'
          }}
          value={{
            county: { value: formik.values.county.id, label: formik.values.county.name },
            city: { value: formik.values.city.id, label: formik.values.city.name }
          }}
          onChange={(newValue: CountyCityInterface, fieldToUpdate: string) =>
            formik.setFieldValue(fieldToUpdate, {
              id: newValue?.value,
              name: newValue?.label
            })
          }
          error={!!formik.errors.county || !!formik.errors.city}
          helperText="required"
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="streetName"
          label="Street name"
          fullWidth
          variant="outlined"
          value={formik.values.streetName}
          onChange={event => formik.setFieldValue('streetName', event.currentTarget.value)}
          error={!!formik.errors.streetName}
          helperText={formik.errors.streetName as string}
          required
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="streetNumber"
          label="Street number"
          fullWidth
          variant="outlined"
          value={formik.values.streetNumber}
          onChange={event => formik.setFieldValue('streetNumber', event.currentTarget.value)}
          error={!!formik.errors.streetNumber}
          helperText={formik.errors.streetNumber as string}
          required
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="entrance"
          label="Entrance"
          fullWidth
          variant="outlined"
          value={formik.values.entrance}
          onChange={event => formik.setFieldValue('entrance', event.currentTarget.value)}
          error={!!formik.errors.entrance}
          helperText={formik.errors.entrance as string}
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="floor"
          label="Floor"
          fullWidth
          variant="outlined"
          value={formik.values.floor}
          onChange={event => formik.setFieldValue('floor', event.currentTarget.value)}
          error={!!formik.errors.floor}
          helperText={formik.errors.floor as string}
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="apartmentNumber"
          label="Appartment number"
          fullWidth
          variant="outlined"
          value={formik.values.apartmentNumber}
          onChange={event => formik.setFieldValue('apartmentNumber', event.currentTarget.value)}
          error={!!formik.errors.apartmentNumber}
          helperText={formik.errors.apartmentNumber as string}
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="postalCode"
          label="Postal Code"
          fullWidth
          variant="outlined"
          value={formik.values.postalCode}
          onChange={event => formik.setFieldValue('postalCode', event.currentTarget.value)}
          error={!!formik.errors.postalCode}
          helperText={formik.errors.postalCode as string}
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="coordinatesX"
          label="Coordinates x"
          fullWidth
          variant="outlined"
          value={formik.values.coordinatesX}
          onChange={event => formik.setFieldValue('coordinatesX', event.currentTarget.value)}
          error={!!formik.errors.coordinatesX}
          helperText={formik.errors.coordinatesX as string}
        />
      </Grid>
      <Grid xs={6} item>
        <Input
          type="text"
          name="coordinatesY"
          label="Coordinates y"
          fullWidth
          variant="outlined"
          value={formik.values.coordinatesY}
          onChange={event => formik.setFieldValue('coordinatesY', event.currentTarget.value)}
          error={!!formik.errors.coordinatesY}
          helperText={formik.errors.coordinatesY as string}
        />
      </Grid>
    </>
  )
}

export default NewAddress
